/* Engraving configurator (gravure-sur-mesure) — layer 2: editor.
   Steps: 1 Bijou · 2 Face · 3 Verso · 4 Récap. Icons and cart come in later layers.
   Engraving geometry is real-scale: the zone is described in mm, the preview maps mm → photo %. */
(function () {
  'use strict';

  var root = document.getElementById('Engraving');
  if (!root) return;

  var BASE = root.getAttribute('data-base') || '';
  var CFG_URL = root.getAttribute('data-config');
  var CAL = /[?&]calibrate=1(&|$)/.test(location.search);
  var NS = 'http://www.w3.org/2000/svg';

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function money(cents) {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  var cfg = null;
  var products = [];
  try { products = JSON.parse($('#egData').textContent); } catch (e) { products = []; }
  products = products.filter(function (p) {
    return p.variants.some(function (v) { return v.available; });
  });

  var S = {
    step: 1,
    product: null,
    variant: null,
    backOn: null, // null = not chosen yet, true/false once chosen
    sides: {
      front: { lines: ['', ''], font: null },
      back: { lines: ['', ''], font: null }
    }
  };
  var CALZ = {}; // calibration overrides, per product handle
  var backFontTouched = false;

  /* ── Config + fonts ───────────────────────────────────────── */
  var fontLoads = {};
  function fontById(id) {
    for (var i = 0; i < cfg.fonts.length; i++) if (cfg.fonts[i].id === id) return cfg.fonts[i];
    return cfg.fonts[0];
  }
  function loadFont(f) {
    if (fontLoads[f.id]) return fontLoads[f.id];
    var face = new FontFace(f.family, 'url(' + BASE + f.file + ')');
    fontLoads[f.id] = face.load().then(function (loaded) {
      document.fonts.add(loaded);
      return true;
    }).catch(function () { return false; });
    return fontLoads[f.id];
  }
  function loadAllFonts() {
    return Promise.all(cfg.fonts.map(loadFont)).then(function () { renderAll(); });
  }

  var mctx = document.createElement('canvas').getContext('2d');
  function measure(text, f, emMm) {
    mctx.font = '100px "' + f.family + '"';
    return mctx.measureText(text).width / 100 * emMm;
  }

  /* ── Zone + layout (all in mm) ────────────────────────────── */
  function getZone() {
    var h = S.product ? S.product.handle : '';
    return CALZ[h] || (cfg.products && cfg.products[h]) || cfg.default_zone;
  }

  function sideLines(side) {
    return side.lines.map(function (l) { return l.trim(); }).filter(Boolean);
  }
  function hasContent(side) { return sideLines(side).length > 0; }

  // Largest size (within the xTool min/max) at which every line fits the zone.
  function layout(side, zoneMm) {
    var f = fontById(side.font);
    var lines = sideLines(side);
    if (!lines.length) return { empty: true, ok: true, lines: [], em: 0, lh: 0, font: f };
    var t = cfg.text, lastEm = 0, lastLh = 0;
    for (var size = t.max_size; size >= t.min_size - 1e-6; size -= 0.5) {
      var em = size * f.em_mm_per_size, lh = em * 1.25;
      var w = 0;
      lines.forEach(function (l) { w = Math.max(w, measure(l, f, em)); });
      var h = (lines.length - 1) * lh + em * 0.9;
      lastEm = em; lastLh = lh;
      if (w <= zoneMm.w && h <= zoneMm.h) return { ok: true, lines: lines, em: em, lh: lh, size: size, font: f };
    }
    return { ok: false, lines: lines, em: lastEm, lh: lastLh, size: t.min_size, font: f };
  }

  function sideStatus(key) {
    var L = layout(S.sides[key], getZone().zone_mm);
    return { content: !L.empty, fits: L.ok };
  }

  /* ── Rendering ────────────────────────────────────────────── */
  function currentImage() {
    if (!S.product) return '';
    return (S.variant && S.variant.image) || S.product.image || '';
  }

  function applyZoneStyle(zoneEl, z) {
    var r = z.zone;
    zoneEl.style.left = r.x * 100 + '%';
    zoneEl.style.top = r.y * 100 + '%';
    zoneEl.style.width = r.w * 100 + '%';
    zoneEl.style.height = r.h * 100 + '%';
    zoneEl.style.transform = r.rotation ? 'rotate(' + r.rotation + 'deg)' : '';
  }

  // Draws photo + engraved text into an already sized .eg-stage
  function renderStage(stage, sideKey, interactive) {
    stage.textContent = '';
    var src = currentImage();
    if (!src) return;
    var img = el('img', 'eg-photo');
    img.src = src;
    img.alt = S.product ? S.product.title : '';
    img.decoding = 'async';
    stage.appendChild(img);

    var z = getZone();
    var side = S.sides[sideKey];
    var sample = CAL && interactive && !hasContent(side);
    var L = layout(sample ? { lines: ['Exemple', ''], font: side.font } : side, z.zone_mm);

    var zoneEl = el('div', 'eg-zone');
    applyZoneStyle(zoneEl, z);
    if (CAL && interactive) zoneEl.classList.add('--cal');
    else if (L.empty && interactive) zoneEl.classList.add('--hint');
    if (!L.ok && interactive) zoneEl.classList.add('--over');

    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + z.zone_mm.w + ' ' + z.zone_mm.h);
    svg.setAttribute('aria-hidden', 'true');
    L.lines.forEach(function (line, i) {
      var t = document.createElementNS(NS, 'text');
      t.setAttribute('x', z.zone_mm.w / 2);
      t.setAttribute('y', z.zone_mm.h / 2 + (i - (L.lines.length - 1) / 2) * L.lh);
      t.setAttribute('text-anchor', 'middle');
      t.setAttribute('dominant-baseline', 'central');
      t.setAttribute('font-family', '"' + L.font.family + '"');
      t.setAttribute('font-size', L.em);
      t.textContent = line;
      svg.appendChild(t);
    });
    zoneEl.appendChild(svg);
    stage.appendChild(zoneEl);
    if (CAL && interactive) attachCalibration(stage, zoneEl);
  }

  function fitStage() {
    var vp = $('#egViewport'), stage = $('#egStage');
    if (!S.product) return;
    var ar = S.product.ratio || 1;
    var w = Math.min(vp.clientWidth, vp.clientHeight * ar);
    stage.style.width = w + 'px';
    stage.style.height = w / ar + 'px';
  }

  function previewSide() { return S.step === 3 ? 'back' : 'front'; }

  function renderPreview() {
    var stage = $('#egStage'), ph = $('#egPlaceholder');
    var has = !!(S.product && S.variant);
    ph.hidden = has;
    stage.hidden = !has;
    $('#egSideTag').hidden = !has || S.step === 1;
    $('#egSideTag').textContent = previewSide() === 'back' ? 'Verso' : 'Face';
    if (!has) return;
    root.style.setProperty('--eg-ar', S.product.ratio || 1);
    fitStage();
    renderStage(stage, previewSide(), true);
  }

  /* ── Step 1: product + variant ────────────────────────────── */
  function minPrice(p) {
    return Math.min.apply(null, p.variants.filter(function (v) { return v.available; }).map(function (v) { return v.price; }));
  }

  function buildProducts() {
    var box = $('#egProducts');
    box.textContent = '';
    products.forEach(function (p) {
      var b = el('button', 'eg-product');
      b.type = 'button';
      b.setAttribute('data-handle', p.handle);
      if (p.image) {
        var im = el('img');
        im.src = p.image.replace(/(width=)\d+/, '$1300');
        im.alt = '';
        im.loading = 'lazy';
        b.appendChild(im);
      }
      b.appendChild(el('span', 'eg-product-name', p.title));
      b.appendChild(el('span', 'eg-product-price', money(minPrice(p))));
      b.addEventListener('click', function () { selectProduct(p); });
      box.appendChild(b);
    });
  }

  function selectProduct(p, variantId) {
    S.product = p;
    var avail = p.variants.filter(function (v) { return v.available; });
    S.variant = avail.filter(function (v) { return String(v.id) === String(variantId); })[0] || avail[0];
    refresh();
  }

  function buildVariants() {
    var wrap = $('#egVariantsWrap'), box = $('#egVariants');
    box.textContent = '';
    if (!S.product || S.product.variants.length < 2) { wrap.hidden = true; return; }
    wrap.hidden = false;
    S.product.variants.forEach(function (v) {
      var b = el('button', 'eg-chip', v.title);
      b.type = 'button';
      b.disabled = !v.available;
      if (S.variant && S.variant.id === v.id) b.classList.add('--selected');
      b.addEventListener('click', function () { S.variant = v; refresh(); });
      box.appendChild(b);
    });
  }

  /* ── Steps 2 & 3: text editor (shared markup) ─────────────── */
  function buildEditor(key) {
    var box = $('#egEditor-' + key);
    box.textContent = '';
    var side = S.sides[key];
    var max = cfg.text.max_chars_guard;

    box.appendChild(el('span', 'eg-label', 'Votre texte (2 lignes maximum)'));
    side.lines.forEach(function (val, i) {
      var inp = el('input', 'eg-input');
      inp.type = 'text';
      inp.value = val;
      inp.maxLength = max;
      inp.placeholder = i === 0 ? 'Ligne 1' : 'Ligne 2 (facultatif)';
      inp.setAttribute('autocomplete', 'off');
      inp.setAttribute('autocorrect', 'off');
      inp.setAttribute('enterkeyhint', i === 0 ? 'next' : 'done');
      inp.setAttribute('aria-label', 'Ligne ' + (i + 1) + ' du texte');
      inp.addEventListener('input', function () { side.lines[i] = inp.value; refresh(true); });
      box.appendChild(inp);
    });

    box.appendChild(el('span', 'eg-label', 'Police'));
    var grid = el('div', 'eg-fonts');
    cfg.fonts.forEach(function (f) {
      var b = el('button', 'eg-font', f.label);
      b.type = 'button';
      b.style.fontFamily = '"' + f.family + '", serif';
      b.setAttribute('data-font', f.id);
      b.setAttribute('aria-pressed', side.font === f.id ? 'true' : 'false');
      if (side.font === f.id) b.classList.add('--selected');
      b.addEventListener('click', function () {
        side.font = f.id;
        if (key === 'back') backFontTouched = true;
        refresh();
      });
      grid.appendChild(b);
    });
    box.appendChild(grid);
    var warn = el('div', 'eg-warn', 'Ce texte est trop long pour ce bijou avec cette police. Raccourcissez-le ou changez de police.');
    warn.id = 'egWarn-' + key;
    warn.setAttribute('role', 'alert');
    warn.hidden = true;
    box.appendChild(warn);
    box.appendChild(el('p', 'eg-hint', 'L’aperçu est à l’échelle réelle de la gravure sur votre bijou.'));
  }

  function syncEditor(key) {
    var side = S.sides[key];
    $$('#egEditor-' + key + ' .eg-font').forEach(function (b) {
      var on = b.getAttribute('data-font') === side.font;
      b.classList.toggle('--selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var st = sideStatus(key);
    $('#egWarn-' + key).hidden = st.fits;
  }

  /* ── Step 4: recap ────────────────────────────────────────── */
  function totalCents() {
    var t = S.variant ? S.variant.price : 0;
    if (S.backOn) t += cfg.pricing.back_surcharge_cents || 0;
    return t;
  }

  function describe(key) {
    var side = S.sides[key];
    return sideLines(side).join(' / ') + ' — ' + fontById(side.font).label;
  }

  function buildRecap() {
    var pair = $('#egRecapPair');
    pair.textContent = '';
    ['front', 'back'].forEach(function (key) {
      var item = el('div', 'eg-recap-item');
      item.appendChild(el('div', 'eg-recap-cap', key === 'front' ? 'Face' : 'Verso'));
      if (key === 'back' && !S.backOn) {
        item.appendChild(el('div', 'eg-recap-none', 'Pas de gravure au verso'));
      } else {
        var st = el('div', 'eg-stage');
        item.appendChild(st);
        renderStage(st, key, false);
      }
      pair.appendChild(item);
    });
    var list = $('#egRecapList');
    list.textContent = '';
    function row(a, b) {
      var li = el('li');
      li.appendChild(el('span', null, a));
      li.appendChild(el('span', null, b));
      list.appendChild(li);
    }
    row('Bijou', S.product.title + (S.product.variants.length > 1 ? ' · ' + S.variant.title : ''));
    row('Face', describe('front'));
    row('Verso', S.backOn ? describe('back') : 'Pas de gravure');
    if (S.backOn && cfg.pricing.back_surcharge_cents > 0) row('Supplément verso', '+' + money(cfg.pricing.back_surcharge_cents));
    row('Total', money(totalCents()));
  }

  /* ── Calibration (admin tool, ?calibrate=1) ───────────────── */
  var calUI = null;
  function cloneZone() { return JSON.parse(JSON.stringify(getZone())); }

  function buildCalPanel() {
    var box = el('div', 'eg-cal');
    box.appendChild(el('strong', null, 'Calibrage de la zone'));
    var grid = el('div', 'eg-cal-grid');
    var fields = [['x', 'X %'], ['y', 'Y %'], ['w', 'L %'], ['h', 'H %'], ['rotation', 'Rot °'], ['mmw', 'L mm'], ['mmh', 'H mm']];
    var inputs = {};
    fields.forEach(function (f) {
      var lab = el('label', null, f[1]);
      var inp = el('input');
      inp.type = 'number';
      inp.step = 'any';
      inp.addEventListener('input', function () {
        if (!S.product) return;
        var z = cloneZone(), v = parseFloat(inp.value);
        if (isNaN(v)) return;
        if (f[0] === 'mmw') z.zone_mm.w = v;
        else if (f[0] === 'mmh') z.zone_mm.h = v;
        else if (f[0] === 'rotation') z.zone.rotation = v;
        else z.zone[f[0]] = v / 100;
        CALZ[S.product.handle] = z;
        refresh(true);
      });
      lab.appendChild(inp);
      grid.appendChild(lab);
      inputs[f[0]] = inp;
    });
    box.appendChild(grid);
    var out = el('textarea');
    out.readOnly = true;
    box.appendChild(out);
    var copy = el('button', 'eg-btn', 'Copier le JSON');
    copy.type = 'button';
    copy.addEventListener('click', function () {
      out.select();
      if (navigator.clipboard) navigator.clipboard.writeText(out.value);
      copy.textContent = 'Copié ✓';
      setTimeout(function () { copy.textContent = 'Copier le JSON'; }, 1500);
    });
    box.appendChild(copy);
    box.appendChild(el('p', 'eg-hint', 'Déplacez le cadre et tirez la poignée sur la photo, saisissez la taille réelle en mm, puis collez le JSON dans products de assets/engraving-config.json.'));
    $('#egPanel').insertBefore(box, $('#egPanel').firstChild);
    calUI = { inputs: inputs, out: out };
  }

  function syncCalPanel() {
    if (!calUI) return;
    if (!S.product) { calUI.out.value = 'Choisissez d’abord un bijou.'; return; }
    var z = getZone(), r = z.zone;
    var round = function (v, n) { return Math.round(v * n) / n; };
    var vals = { x: round(r.x * 100, 100), y: round(r.y * 100, 100), w: round(r.w * 100, 100), h: round(r.h * 100, 100), rotation: r.rotation || 0, mmw: z.zone_mm.w, mmh: z.zone_mm.h };
    Object.keys(vals).forEach(function (k) {
      if (document.activeElement !== calUI.inputs[k]) calUI.inputs[k].value = vals[k];
    });
    var obj = {};
    obj[S.product.handle] = {
      zone: { x: round(r.x, 1000), y: round(r.y, 1000), w: round(r.w, 1000), h: round(r.h, 1000), rotation: r.rotation || 0 },
      zone_mm: { w: z.zone_mm.w, h: z.zone_mm.h }
    };
    calUI.out.value = JSON.stringify(obj, null, 1).slice(2, -2);
  }

  function attachCalibration(stage, zoneEl) {
    var handle = el('div', 'eg-zone-h');
    zoneEl.appendChild(handle);
    function start(e, mode) {
      e.preventDefault();
      e.stopPropagation();
      var rect = stage.getBoundingClientRect();
      var z0 = cloneZone(), sx = e.clientX, sy = e.clientY, h = S.product.handle;
      function move(ev) {
        var z = JSON.parse(JSON.stringify(z0));
        var dx = (ev.clientX - sx) / rect.width, dy = (ev.clientY - sy) / rect.height;
        if (mode === 'move') {
          z.zone.x = clamp(z0.zone.x + dx, 0, 1 - z0.zone.w);
          z.zone.y = clamp(z0.zone.y + dy, 0, 1 - z0.zone.h);
        } else {
          z.zone.w = clamp(z0.zone.w + dx, 0.03, 1 - z0.zone.x);
          z.zone.h = clamp(z0.zone.h + dy, 0.03, 1 - z0.zone.y);
        }
        CALZ[h] = z;
        applyZoneStyle(zoneEl, z);
        syncCalPanel();
      }
      function up() {
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', up);
        refresh(true);
      }
      window.addEventListener('pointermove', move);
      window.addEventListener('pointerup', up);
    }
    zoneEl.addEventListener('pointerdown', function (e) { start(e, 'move'); });
    handle.addEventListener('pointerdown', function (e) { start(e, 'resize'); });
  }

  /* ── Steps, progress, validation ──────────────────────────── */
  function canReach(n) {
    if (n <= 1) return true;
    if (!S.product || !S.variant) return false;
    if (n === 2) return true;
    var f = sideStatus('front');
    if (!(f.content && f.fits)) return false;
    if (n === 3) return true;
    if (S.backOn === null) return false;
    if (S.backOn) {
      var b = sideStatus('back');
      if (!(b.content && b.fits)) return false;
    }
    return true;
  }

  function goStep(n) {
    if (!canReach(n)) return;
    var prev = S.step;
    S.step = n;
    // The back starts with the front font until the customer picks another one
    if (n === 3 && !backFontTouched) S.sides.back.font = S.sides.front.font;
    refresh();
    if (n !== prev) {
      var bar = $('#egProgress');
      if (window.innerWidth <= 900 && bar.scrollIntoView) bar.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function refreshProgress() {
    var steps = $$('.eg-progress-step'), lines = $$('.eg-progress-line');
    steps.forEach(function (b, i) {
      var n = i + 1;
      b.classList.toggle('--active', n === S.step);
      b.classList.toggle('--done', n < S.step);
      b.classList.toggle('--reachable', n !== S.step && canReach(n));
      b.disabled = !(n === S.step || canReach(n));
      if (n === S.step) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
    });
    lines.forEach(function (l, i) { l.classList.toggle('--done', i + 1 < S.step); });
  }

  // light = true while typing: do not rebuild inputs (keeps focus and caret)
  function refresh(light) {
    $$('[data-wizard-step]').forEach(function (s) { s.hidden = Number(s.getAttribute('data-wizard-step')) !== S.step; });
    root.classList.toggle('--recap', S.step === 4);

    $$('.eg-product').forEach(function (b) {
      b.classList.toggle('--selected', !!S.product && b.getAttribute('data-handle') === S.product.handle);
    });
    if (!light) buildVariants();
    $('#egNext1').disabled = !(S.product && S.variant);

    syncEditor('front');
    syncEditor('back');
    $('#egNext2').disabled = !canReach(3);
    $('#egNext3').disabled = !canReach(4);
    $$('.eg-choice').forEach(function (b) {
      var on = (b.getAttribute('data-back') === 'yes') === S.backOn && S.backOn !== null;
      b.classList.toggle('--selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $('#egEditor-back').hidden = S.backOn !== true;
    var sur = cfg.pricing.back_surcharge_cents || 0;
    $('#egBackYes').textContent = sur > 0 ? 'Graver le verso (+' + money(sur) + ')' : 'Graver le verso';

    refreshProgress();
    renderPreview();
    if (S.step === 4 && S.product) buildRecap();
    syncCalPanel();
  }

  function renderAll() { refresh(true); }

  /* ── Init ─────────────────────────────────────────────────── */
  function bind() {
    $$('.eg-progress-step').forEach(function (b, i) {
      b.addEventListener('click', function () { goStep(i + 1); });
    });
    $('#egNext1').addEventListener('click', function () { goStep(2); });
    $('#egBack2').addEventListener('click', function () { goStep(1); });
    $('#egNext2').addEventListener('click', function () { goStep(3); });
    $('#egBack3').addEventListener('click', function () { goStep(2); });
    $('#egNext3').addEventListener('click', function () { goStep(4); });
    $('#egBack4').addEventListener('click', function () { goStep(3); });
    $$('.eg-choice').forEach(function (b) {
      b.addEventListener('click', function () {
        S.backOn = b.getAttribute('data-back') === 'yes';
        refresh();
      });
    });
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { if (S.product && S.variant) fitStage(); }, 100);
    });
    if (window.ResizeObserver) new ResizeObserver(function () { if (S.product && S.variant) fitStage(); }).observe($('#egViewport'));
  }

  function init() {
    S.sides.front.font = S.sides.back.font = cfg.fonts[0].id;
    buildProducts();
    buildEditor('front');
    buildEditor('back');
    if (CAL) buildCalPanel();
    bind();

    var q = new URLSearchParams(location.search);
    var wanted = products.filter(function (p) { return p.handle === q.get('product'); })[0];
    if (wanted) selectProduct(wanted, q.get('variant'));
    else if (products.length === 1) selectProduct(products[0]);
    else refresh();

    if (!products.length) $('#egEmpty').hidden = false;
    // Selected font first so the preview is right, then the rest for the font picker
    loadFont(fontById(S.sides.front.font)).then(renderAll);
    loadAllFonts();
  }

  fetch(CFG_URL).then(function (r) {
    if (!r.ok) throw new Error(r.status);
    return r.json();
  }).then(function (c) {
    cfg = c;
    init();
  }).catch(function () {
    var m = $('#egError');
    if (m) m.hidden = false;
  });
})();
